import type { ReactNode } from "react";
import * as Styled from "./styled";

type Props = {
  children?: ReactNode;
  heading?: string;
  description?: string;
};

const IntroPanel = ({ children, heading, description }: Props) => {
  return (
    <Styled.IntroPanel>
      {heading && (
        <Styled.Content>
          <Styled.Heading>{heading}</Styled.Heading>
          {description && (
            <div dangerouslySetInnerHTML={{ __html: description }} />
          )}
        </Styled.Content>
      )}
      {children}
    </Styled.IntroPanel>
  );
};

export default IntroPanel;
